export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-de.0ad60a6f.png";